
import React, { Component } from 'react';

import API from '../../lib/api.js';

import {
  emailField,
  nameField,
  subjectField,
  messageBodyField,

  handlerFor,

  alertDismissState,

  getInitialState
} from './contact';

import ContactForm from './ContactForm';

import './index.css';

export default class ContactFormContainer extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAlertDismiss = this.handleAlertDismiss.bind(this);

    this.state = getInitialState();

    // // ...
    // API.retrieve().then((response) => {
    //   console.log('OK...', response);
    // })
    // .catch((response) => {
    //   console.log('ERROR...', response);
    // });
  }

  validateField({ value, id, optionFor }) {
    const handler = handlerFor[id];

    if (handler) {
      if (handler.isValid(value, optionFor)) {
        this.setState({
          ...this.state,
          [id]: {
            validation: null,
            isValid: true,
            helpMsg: handler.default.helpMsg,
            helpVisibility: handler.default.helpVisibility,
            value
          }
        });
      } else {
        this.setState({
          ...this.state,
          [id]: {
            validation: 'error',
            isValid: false,
            helpMsg: handler.failedValidationMessage,
            helpVisibility: 'visible',
            value
          }
        });
      }
    } else {
      console.log(`ERROR: no handler for ID '${id}'`);
    }
  }

  fieldIsValid({ id, value, optionFor }) {
    const handler = handlerFor[id];

    if (handler) {
      if (handler.isValid(value, optionFor)) {
        return true;
      }
      return false;
    }

    console.log(`ERROR: no handler for ID '${id}'`);
    return null;
  }

  getValidState({ id, value }) {
    const handler = handlerFor[id];

    return {
      ...this.state,
      [id]: {
        validation: null,
        isValid: true,
        helpMsg: handler.default.helpMsg,
        helpVisibility: handler.default.helpVisibility,
        value
      }
    };
  }

  getInvalidState({ id, value }) {
    const handler = handlerFor[id];

    return {
      ...this.state,
      [id]: {
        validation: 'error',
        isValid: false,
        helpMsg: handler.failedValidationMessage,
        helpVisibility: 'visible',
        value
      }
    };
  }

  handleChange(evt) {
    const { id, value } = evt.target;

    if (this.fieldIsValid({ id, value })) {
      this.setState({
        ...this.getValidState({ id, value }),

        // ... why? Because we want to remove the alert as new inputs arrive.
        ...alertDismissState
      });
    } else {
      this.setState({
        ...this.getInvalidState({ id, value }),
        // ... see above
        ...alertDismissState
      });
    }
  }

  handleAlertDismiss() {
    this.setState({
      ...this.state,
      ...alertDismissState
    });
  }

  handleSubmit(evt) {
    const { state } = this;
    const email = state[emailField.id];
    const name = state[nameField.id];
    const subject = state[subjectField.id];
    const msgBody = state[messageBodyField.id];

    const invalidState = [
      nameField, subjectField, messageBodyField
    ].filter(({ id }) => !state[id].isValid).reduce(
      (acc, { id }) => {
        return this.getInvalidState({ id: id, value: state[id].value });
      }, {}
    );

    const emID = emailField.id;
    const emValue = email.value;

    const invalidEmailState = !this.fieldIsValid({
      id: emID, value: emValue, optionFor: { checkMinChars: false }
    }) && this.getInvalidState({ id: emID, value: emValue });

    if (invalidEmailState) invalidState[emID] = invalidEmailState[emID];

    if (Object.keys(invalidState).length > 0) {
      this.setState({
        ...this.state,
        ...invalidState,
        alert: {
          msg: 'One or more fields are not valid',
          visible: true
        }
      });

      evt.preventDefault();
      return;
    }

    console.log('POST-ing...');
    console.log({
      to: null,
      from: email.value,
      subject: subject.value || 'No subject',
      name: name.value || 'No name',
      text: msgBody.value
    });

    API.message({
      from: email.value,
      subject: subject.value || 'No subject',
      name: name.value || 'No name',
      text: msgBody.value
    }).then((response) => {
      const messageTitle = 'Your message has been sent...';

      console.log(messageTitle);
      console.log({ response });

      this.setState({
        ...this.state,
        alert: {
          bsStyle: 'success',
          messageTitle,
          msg: 'I\'ll get back to you as soon as possible' +
            ' ' +
            `at this email address you provided: "${email.value}".`,
          visible: true
        }
      });
    }).catch((response) => {
      console.log('ERROR...');
      console.log(response);

      this.setState({
        ...this.state,
        alert: {
          msg: response.message,
          visible: true
        }
      });
    });

    // ... keep this, obvs.
    evt.preventDefault();
  }

  render() {
    const { state } = this;

    return (
      <ContactForm
        state={state}
        emailField={emailField}
        nameField={nameField}
        subjectField={subjectField}
        messageBodyField={messageBodyField}

        handleSubmit={this.handleSubmit}
        handleChange={this.handleChange}
        handleAlertDismiss={this.handleAlertDismiss}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/contact/ContactFormContainer.js